import React from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import Divider from '@mui/material/Divider';

const PulseBox = ({
  width,
  height,
  delay = '0s',
}: {
  width: string | number;
  height: number;
  delay?: string;
}) => (
  <Box
    sx={{
      height,
      borderRadius: 1,
      bgcolor: 'action.hover',
      width,
      animation: `pulse 1.5s ease-in-out ${delay} infinite`,
      '@keyframes pulse': {
        '0%, 100%': { opacity: 1 },
        '50%': { opacity: 0.4 },
      },
    }}
  />
);

const SkeletonRow = () => (
  <Box
    display="flex"
    gap={1}
    alignItems="flex-start"
    width="100%"
    height="89px"
    py={1}
    px={{ xs: 1, sm: 2 }}
    sx={{ boxSizing: 'border-box' }}
  >
    <Box
      display="flex"
      alignItems="center"
      gap={{ xs: 0.5, sm: 0.75 }}
      flexShrink={0}
    >
      <Box width={8} />
      <Box
        sx={{
          width: { xs: 36, sm: 40 },
          height: { xs: 36, sm: 40 },
          borderRadius: '50%',
          bgcolor: 'action.hover',
          animation: 'pulse 1.5s ease-in-out infinite',
          '@keyframes pulse': {
            '0%, 100%': { opacity: 1 },
            '50%': { opacity: 0.4 },
          },
        }}
      />
    </Box>
    <Box
      display="flex"
      flexDirection="column"
      minWidth={0}
      flex={1}
      gap={0.75}
      pt={0.5}
    >
      <PulseBox width="60%" height={14} />
      <PulseBox width="85%" height={12} delay="0.15s" />
      <PulseBox width="45%" height={12} delay="0.3s" />
    </Box>
  </Box>
);

type OutlookEmailListSkeletonProps = {
  count?: number;
};

const OutlookEmailListSkeleton = ({
  count = 4,
}: OutlookEmailListSkeletonProps) => (
  <Box display="flex" flexDirection="column" flex={1} minHeight={0}>
    <Box
      flex={1}
      minHeight={0}
      sx={{ maxHeight: '440px', overflowY: 'hidden' }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <React.Fragment key={i}>
          <SkeletonRow />
          <Divider sx={{ width: '100%', mx: 0, my: 0 }} />
        </React.Fragment>
      ))}
    </Box>
  </Box>
);

export default OutlookEmailListSkeleton;
